import { render } from "./OurCustomerReviews.vue?vue&type=template&id=66376259&scoped=true"
import script from "./OurCustomerReviews.vue?vue&type=script&lang=js"
export * from "./OurCustomerReviews.vue?vue&type=script&lang=js"

import "./OurCustomerReviews.vue?vue&type=style&index=0&id=66376259&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66376259"]])

export default __exports__